<template>
    <div class="content-wrapper">
        <div class="ibox-title">
            <h5 id="h5Title">{{isEdit?'修改':'添加'}}体质数据</h5>
        </div>
        <div class='worker_data ibox-content' style="padding-left: 0;">
            <div class="nav_cha">体质信息</div>
            <div>
                <el-form :inline="true" :model="dataform" :rules="rules" ref="form" label-width="120px" label-position="right"
                class="demo-form-inline" id="childPhyAdd">
                 <el-form-item label="评定标准：" prop='specId' style="width:380px">
                        <el-select v-model="dataform.specId" placeholder="请选择体检类型" :disabled="isEdit" style="width:200px">
                            <el-option v-for="item in standList" :key="item.id" :label="item.standardName" :value="item.id"  ></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="测试日期：" prop='dataDate' style="width:380px">
                        <el-date-picker v-model="dataform.dataDate" value-format='yyyy-MM-dd' type="date" placeholder="选择体检日期"
                        style="width:200px" :picker-options="pickerOptions"></el-date-picker>
                    </el-form-item>
                    <div class="nav_cha">儿童信息</div>
                     <el-form-item label="姓名：" prop="childName"  style="width:380px">
                       <el-autocomplete v-model="dataform.childName"  :trigger-on-focus="false" style="width:200px" :disabled="isEdit"  :fetch-suggestions="searchStuByhhs" placeholder="请输入儿童姓名" value-key="childName" @select="selectChild">

                       </el-autocomplete>

                        <!-- <el-select
                          v-model="dataform.studentId"
                          filterable
                          remote
                          allow-create
                          @change="selectStu"
                          reserve-keyword
                          placeholder="请输入儿童姓名" style="width:200px"
                          :remote-method="searchStuByhhs"
                          :loading="loadingStuList" value-key="childID">
                          <el-option
                            v-for="item in studentList"
                            :key="item.childID"
                            :label="item.childName"
                            :value="item">
                          </el-option>
                        </el-select> -->

                    </el-form-item>

                    <el-form-item label="性别：" prop="sex" style="width:380px" id="sex">
                    <el-select v-model="dataform.sex" :disabled="isEdit" style="width:200px" placeholder=""  ref="sex">
                        <el-option key="男" label="男" value="男"></el-option>
                        <el-option key="女" label="女" value="女"></el-option>
                    </el-select>

                    </el-form-item>
                    <el-form-item label="出生日期：" prop="birthday" style="width:380px" id="birthday">
                        <el-date-picker v-model="dataform.birthday" :disabled="disabledChildInfo||isEdit" value-format='yyyy-MM-dd' type="date" style="width:200px" > </el-date-picker>
                    </el-form-item>
                    <el-form-item label="身份证号码："  prop='idCard' style="width:380px">
                        <el-input v-model="selChild.idCard" style="width:200px" :disabled="disabledChildInfo||isEdit" ref="idCard"></el-input>
                    </el-form-item>
                    <el-form-item label="联系人："  prop='relation' style="width:380px">
                        <el-input v-model="selChild.relation" style="width:200px"  :disabled="disabledChildInfo||isEdit" ref="relation"></el-input>
                    </el-form-item>
                    <el-form-item label="手机号码：" prop='relationPhone' style="width:380px">
                        <el-input v-model="selChild.relationPhone" style="width:200px" :disabled="disabledChildInfo||isEdit" ref="relationPhone"></el-input>
                    </el-form-item>
                  
                    <div class="nav_cha">测试信息</div>
                  

                    <!-- <el-form :model="dataform.itemMap" ref="checkForm" label-width="100px" style='width:100%;'> -->
                      <template v-if='dataform.itemMap' v-for='(item, num) in standComponents'>
                        <template v-if='item.itemType=="INPUT"'>
                          <input-com :label='item.displayName' :key="num" :prop='item.itemCode' :val='dataform.itemMap[item.itemCode]' :detail='item.details'></input-com>
                        </template>
                      </template>
                      <div class='clear'></div>
                    <!-- </el-form> -->

                    <div class='hold' style="margin-top:20px">
                        <!-- <el-form-item> -->
                            <el-button class="btn-primary" type="primary" size='small' @click='submit'>保存</el-button>
                            <el-button class="btn-primary" type="primary" size='small' @click="onReset" v-show="!isEdit">重置</el-button>
                        <!-- </el-form-item> -->
                    </div>
                </el-form>
                <!--<el-input ref="input" style="width:150px"></el-input>-->
            </div>
        </div>
    </div>
</template>
<script>
    import api from '../../com/ajax' // ajax请求封装
    import config from '../../com/config' // url配置文件
    import inputCom from '../utils/inputCom.vue'

    export default {
      data () {
        return {
          standList:[],// 标准集合
          dataform:{
            specId:'',
            itemMap:{},
            dataDate:'',
            studentId:'',
            childName:'',
            sex:'',
            birthday:'',
            dataVersion:'',
            id:''
          },
          selChild:{
            idCard:'',
            relation:'',
            relationPhone:''
          },
          standComponents:[],//标准的控件集合
          studentList:[],//学生列表
          disabledChildInfo:false,//是否禁用儿童相关信息
          isEdit:false,
          // loadingStuList:false,//搜索时候的加载中动画


          pickerOptions: {// 只能选择今天以前的日期
            disabledDate (time) {
              return time.getTime() > Date.now() - 8.64e6
            }
          },

          rules: {
            mecType: [
              { required: true, message: '请输入体检类型', trigger: 'change' },
              { required: true, message: '请输入体检类型', trigger: 'blur' }
            ],
            dataDate: [
              { required: true, message: '请选择体检日期', trigger: 'change' },
              { required: true, message: '请选择体检日期', trigger: 'blur' }
            ],
            childName: [
              { required: true, message: '请输入儿童姓名', trigger: 'change' },
              { required: true, message: '请输入儿童姓名', trigger: 'blur' }
            ],
            sex: [
              { required: true, message: '请选择性别', trigger: 'change' }
            ],
            birthday: [
              { required: true, message: '请选择生日', trigger: 'change' }
            ],
          }
        }
      },
      components: {
        inputCom: inputCom
      },
      methods: {
        // selectStu(item){
        //   if(item.sex){
        //     this.dataform.sex=item.sex
        //     this.dataform.birthday=item.birthday
        //     this.selChild=item
        //   }
        //   else{
        //      this.dataform.sex=''
        //      this.dataform.birthday=''
        //      this.selChild.relation=''
        //      this.selChild.relationPhone=''
        //      this.selChild.idCard=''
        //   }
        // },
        selectChild(item){//选择了儿童
          this.dataform.studentId=item.childID

          this.dataform.sex=item.sex
          this.dataform.birthday=item.birthday
          //this.selChild=item
          this.selChild.idCard=item.idCard
          this.selChild.relation=item.relation
          this.selChild.relationPhone=item.relationPhone
          this.disabledChildInfo=true
        },
        searchStuByhhs(query, cb){// 查询儿童
        let self=this
          if (query) {
            // self.loadingStuList=true
            self.dataform.studentId=''
            self.disabledChildInfo=false
            self.dataform.sex=''
            self.dataform.birthday=''
            self.selChild.relation=''
            self.selChild.relationPhone=''
            self.selChild.idCard=''
            
            self.send(config.host +self.$api.getHhsStudentList,{"childName":query} ,false).then((data)=>{
              if(data.success){
                // self.studentList=data.body
                 cb(data.body);
              }
              else{
                self.$message.error('查询数据异常!')
              }
              // self.loadingStuList=false
            })
          }
        },
        initStandComponents(){//初始化加载标准组件
          let self = this
          return new Promise((resolve)=>{
             self.send(config.khsHost +self.$api.getStandComponents+self.dataform.specId,{},true).then((data)=>{
           
              if(data.success){
                resolve(data)
              }
              else{
                self.$message.error('标准数据异常!')
                resolve('')
              }
            })
          })
         
        },
        getDetailById(id){//获取体质数据详情
          let self = this
          return new Promise((resolve)=>{
             self.send(config.khsHost +self.$api.getPecInfo+id,{},true).then((data)=>{
               
              if(data.success){
                resolve(data)
              }
              else{
                self.$message.error('查询数据异常!')
                resolve('')
              }
            })
          })
        },
        getChildDetailById(id){//获取儿童数据详情
          let self = this
          return new Promise((resolve)=>{
             self.send(config.host +self.$api.getChildInfo,{childID:id},false).then((data)=>{
               
              if(data.success){
                resolve(data)
              }
              else{
                self.$message.error('查询数据异常!')
                resolve('')
              }
            })
          })
        },
        send(url,pram,isGet){// 进行ajax发送
          return new Promise((resolve)=> {
            if(isGet){
              api.get( url, pram).then(function (data) {
                resolve(data)
              })
            }
            else{
              api.post( url, pram).then(function (data) {
                resolve(data)
              })
            }
          })
        },
        addChild(childInfo){
          let self=this
          return new Promise((resolve)=>{
              if(!self.dataform.studentId){
                self.send(config.host +self.$api.addChildInfo,childInfo,false).then((data)=>{
                  if(data.success){
                    //添加儿童成功
                    self.dataform.studentId=data.body.childID
                    resolve(true)

                  }
                  else{
                    // self.$message.error('无标准数据!')
                    resolve(false)
                  }
                })
              }
              else{
                 resolve(true)
              }
          })
        },
        addPecData(){// 添加体质数据
          let self=this
          return new Promise((resolve)=>{
            self.send(config.khsHost +self.$api.addPecInfo,self.dataform,false).then((data)=>{
              if(data.success){
                self.$message.success('添加成功!')
              }
              else{
                // self.$message.error('无标准数据!')
              }
              resolve(data.success)
            })
          })
         
        },
        updatePecData(){// 修改体质数据
          let self=this
          return new Promise((resolve)=>{
            self.send(config.khsHost +self.$api.updatePecInfo,self.dataform,false).then((data)=>{
              if(data.success){
                self.$message.success('修改成功!')
              }
              else{
                // self.$message.error('无标准数据!')
              }
              resolve(data.success)
            })
          })
         
        },
        submit () { // 提交
        var self = this
          
          self.$refs.form.validate(valid => {
            if (valid) {
                  var num = 0
                  if (self.dataform.itemMap) {
                    for (var i in self.dataform.itemMap) {
                      if (self.dataform.itemMap[i].value !== '') {
                        if (!isNaN(Number(self.dataform.itemMap[i].value))) {
                          self.dataform.itemMap[i].value = Number(
                            self.dataform.itemMap[i].value
                          )
                        }
                        num++
                      }
                    }
                  } else {
                    return false
                  }

                  if (num > 0) {

                        if(self.isEdit){//修改
                          self.updatePecData().then((flag)=>{
                            if(flag){
                              //关闭弹窗
                              self.$emit('close',false,true)
                            }
                          })

                        }
                        else{//添加 
                          // 没有该儿童数据进行添加儿童然后在添加体质数据
                          let childInfo=self.selChild
                          childInfo.childName=self.dataform.childName
                          childInfo.sex=self.dataform.sex
                          childInfo.birthday=self.dataform.birthday
                          self.addChild(childInfo).then((flag)=>{
                            if(flag){
                              //添加体质数据
                              self.addPecData().then((flag)=>{
                                if(flag){
                                  //关闭弹窗
                                  self.$emit('close',false,true)                                  
                                }
                              })
                            }
                          })
                        }
                      
                      
                  } else {
                    self.$message.error('请至少输入一项测试指标')
                  }
            }
          })
        },
        onReset () { // 重置
          var self = this
          self.dataform.dataDate=''
          self.dataform.studentId=''
          self.dataform.childName=''
          self.dataform.sex=''
          self.dataform.birthday=''
            //specId:'', 不能重置，因为重置后要重新渲染请求组件
            //itemMap:{},不能重置，因为重置后要重新渲染请求组件
            //dataVersion:'',不能重置，因为重置后要重新渲染请求组件
          self.selChild.idCard=''
          self.selChild.relation=''
          self.selChild.relationPhone=''
          // self.$refs.dataform.resetFields()
          for (let i in self.dataform.itemMap) {
            self.dataform.itemMap[i].value =''
          }
          // self.$refs.formInline.resetFields()
          // // 获取检查项目模块
          // api.post(config.host + 'childMec/getCategoryList.do').then(function (response) {
          //   self.CategoryList = response.body

          //     // 获取检查项目模块
          //   api.post(config.host + 'childMec/getItemDetailList.do').then(function (response) {
          //     self.detailList = response.body
          //   })
          // })
          // $('.setInput').hide()
        }
      },
      created () {
        var self = this
        /**一、初始化部分
         * 
         * 1.加载评定标准，默认选中一项评定标准
         *  ｛
         *      根据评定标准初始化加载动态的测试信息部分控件
         *   ｝
         *    
         */

          //1.加载评定标准，默认选中一项评定标准
          self.send(config.khsHost +self.$api.getStandardList,{},true).then((data)=>{
            //判断是否有无标准，如果没有则显示需要进行添加的页面跳转
            if(data.success&&data.body.length>0){
              self.standList=data.body
              //如果有标准的话默认读取一个标准
              self.dataform.specId=self.$route.query.specId||data.body[0].id
              //如果有标准的话初始化加载动态的测试信息部分控件
              self.initStandComponents().then((data)=>{
                self.dataform.dataVersion=data.body.version
                
                if(data){

                  //获取动态标准项
                  let checkItem=data.body.items

                  let id=self.$route.query.id
                  let childId=self.$route.query.childId
                  
                  if(id&&childId){
                    self.dataform.id=id
                    self.dataform.studentId=childId
                    //获取儿童数据详情
                    self.getChildDetailById(childId).then((data)=>{
                      data=data.body.list
                      self.dataform.childName=data.childName
                      self.dataform.birthday=data.birthday
                      self.selChild.idCard=data.idCard
                      self.selChild.relation=data.relation
                      self.selChild.relationPhone=data.relationPhone
                      self.dataform.sex=data.sex
                      self.isEdit=true
                    })
                    //获取体质数据详情
                    self.getDetailById(id).then((data)=>{
                      let itemMap = data.body.itemMap
                      self.dataform.dataVersion=data.body.dataVersion
                      self.dataform.dataDate=data.body.dataDate
                      checkItem.forEach(function(i, num) {
                        var value = ''
                        if (itemMap[i.itemCode]) {
                          value = itemMap[i.itemCode].value
                        }
                        self.$set(self.dataform.itemMap, i.itemCode, { value: value })
                        // that.oldItemMap = JSON.stringify(that.form.itemMap)
                        if (num == checkItem.length - 1) {
                          self.standComponents = checkItem
                        }
                      })
                    })

                  }
                  else{
                    // 添加的动作
                    for (let i in checkItem) {
                      var item = checkItem[i]
                      self.$set(self.dataform.itemMap, item.itemCode, { value: '' })
                    }
                    self.standComponents=checkItem
                  }

                }
              })
            }
            else{
              self.$message.error('无标准数据!')
            }
          })
          






        // self.loadInt()
      },
      // watch: {
      //   $route: {
      //     handler: function () {
      //       var self = this
      //       self.loadInt()
      //     },
      //     deep: true
      //   }
      // }
    }
</script>
<style>
    #childPhyAdd .el-form-item__content{
      vertical-align: top;
    }
    .nav_cha {
        padding-left: 10px;
        border-left: 5px solid #1ab394;
        height: 16px;
        line-height: 16px;
        margin: 12px;
        font-weight: bold;
        text-align: left;
    }

    .red {
        color: red;
        position: relative;
        left: 30px;
        top: 10px
    }

    .red1 {
        color: red;
        position: relative;
        left: 15px;
        top: 10px
    }

    .red2 {
        color: red;
        position: relative;
        top: 10px
    }

    .float {
        position: absolute;
        bottom: 0px;
        right: -45px;
    }

    .evaluate {
        width: 80%;
        margin-left: 27px;
    }

    .evaluate .el-form-item__content{
        width: 100%;
    }

    .hold {
        margin: auto;
        width: 200px;
    }
    .nav_gen{
        width:82%;
        height: 46px;
        line-height: 46px;
        margin: 12px;
        font-weight: bold;
        text-align: left;
    }
    .setLine{
        padding-left: 10px;
        border-left: 5px solid #1ab394;
    }
    .setBtn{
        display: inline-block;
        float : right;
    }
    .star .el-form-item__label:before{
      content: '*';
      color: #f56c6c;
      margin-right: 4px;
    }
    /* 选用模板弹窗 */
    .innerDialog .el-dialog{
      min-height:600px;
    }
    .module_left {
				height: 100%;
				float: left;
				width: 27%;
				min-height: 340px;
				border: 1px solid #DDDDDD;
				-webkit-box-sizing: border-box;
				-moz-box-sizing: border-box;
			}
      #dislist .el-checkbox{
        margin-left:0
      }
      #dislist li{
        list-style-type: none
      }
			.msgtit {
				border-bottom: 1px solid #DDDDDD;
				height: 38px;
				line-height: 38px;
				font-size: 16px;
				font-weight: bold;
				padding-left: 20px;
				background: #f6f6f6;
			}

      .module_right {
				position: relative;
				float: left;
				width: 73%;
        border: 1px solid #ddd;
        min-height: 340px;
			}
      #module_main{
        padding-left:20px;
      }
      #dislist .el-checkbox+.el-checkbox{
        margin-left:0;
      }
</style>


// WEBPACK FOOTER //
// src/components/physique/physiqueEdit.vue?14f9b68c